import React, { useEffect, useState } from 'react';
import { Form, Row, Col, } from 'react-bootstrap';
import Select from 'react-select';

import HabilitationService from 'services/habilitationsService';

import { Link } from 'react-router-dom';

const DemandeDPSStep1 = ({
    register,
    errors,
    setValue,
    watch,
}) => {
    const [structures, setStructures] = useState([]);

    useEffect(() => {
        if(!watch("step1") || watch("step1") != true)
        {
            if(HabilitationService.habilitations)
            {
                setValue("orgaRepresentePar", HabilitationService.habilitations.nomClient + ' ' + HabilitationService.habilitations.prenomClient);
                setValue("orgaRepresenteParMail", HabilitationService.habilitations.mailClient);
                setValue("orgaRepresenteParTel", HabilitationService.habilitations.telClient);
            }

            if(HabilitationService.habilitations && HabilitationService.habilitations.structures && HabilitationService.habilitations.structures.length > 0)
            {
                let tempStructures = [];
                for(const structure of HabilitationService.habilitations.structures)
                {
                    tempStructures.push({
                        ...structure,
                        label: structure.nomStructureClient,
                        value: structure.idStructureClient,
                    })
                }
                setStructures(tempStructures);

                if(!watch('idStructureClient')){setValue("idStructureClient", tempStructures[0])}else{
                    if(Number.isInteger(watch('idStructureClient')))
                    {
                        setValue("idStructureClient", tempStructures.filter(struct => struct.idStructureClient == watch('idStructureClient'))[0])
                    }
                }
            }
        }
    },[]);

    useEffect(()=>{
        if(watch("idStructureClient") && watch("idStructureClient").idStructureClient > 0)
        {
            let oneStruct = HabilitationService.habilitations.structures.filter(struct => struct.idStructureClient == watch("idStructureClient").idStructureClient)[0];
            setValue("orgaRaisonSociale", oneStruct.nomStructureClient);
            setValue("orgaAdresse", oneStruct.adresseStructureClient);
            setValue("orgaRepresentantLegal", oneStruct.representantLegalStructureClient);
            setValue("orgaRepresentantLegalFonction", oneStruct.representantLegalFonctionStructureClient);
            setValue("orgaRepresentantLegalMail", oneStruct.representantLegalMailStructureClient);
            setValue("orgaRepresentantLegalTel", oneStruct.representantLegalTelStructureClient);
            setValue("orgaFacturationMail", oneStruct.facturationMailStructureClient);
            setValue("orgaFacturationTel", oneStruct.facturationTelStructureClient);
        }
    },[watch("idStructureClient")])

    const contactSurPlaceIdentique = () => {
        if(HabilitationService.habilitations)
        {
            setValue("orgaContactLocal", HabilitationService.habilitations.nomClient + ' ' + HabilitationService.habilitations.prenomClient);
            setValue("orgaContactLocalFonction", watch("orgaRepresenteParFonction"));
            setValue("orgaContactLocalTel", HabilitationService.habilitations.telClient);
        }else{
            setValue("orgaContactLocal", watch("orgaRepresentePar"));
            setValue("orgaContactLocalFonction", watch("orgaRepresenteParFonction"));
            setValue("orgaContactLocalTel", watch("orgaRepresenteParTel"));
        }
    }

    return (<>
        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Votre structure</h5></center>

            {HabilitationService.habilitations ? <>
                <Form.Group className="mb-3">
                    <Form.Label>Votre structure</Form.Label>
                    <Select
                        id="idStructureClient"
                        name="idStructureClient"
                        size="sm"
                        classNamePrefix="react-select"
                        closeMenuOnSelect={true}
                        isClearable={true}
                        isSearchable={true}
                        options={structures}
                        value={watch("idStructureClient")}
                        onChange={selected => setValue("idStructureClient", selected)}
                        placeholder="Selectionnez votre structure"
                    />
                    <small className="text-danger">{errors.idStructureClient?.message}</small>
                </Form.Group>
            </>:null}

            <Row>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Raison sociale</Form.Label>
                        <Form.Control type="text" name="orgaRaisonSociale" id="orgaRaisonSociale" {...register("orgaRaisonSociale")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaRaisonSociale}/>
                        <small className="text-danger">{errors.orgaRaisonSociale?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Adresse</Form.Label>
                        <Form.Control as="textarea" rows={4} name="orgaAdresse" id="orgaAdresse" {...register("orgaAdresse")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaAdresse}/>
                        <small className="text-danger">{errors.orgaAdresse?.message}</small>
                    </Form.Group>
                </Col>
            </Row>

            <hr/>

            <Row>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Représentant Légal</Form.Label>
                        <Form.Control type="text" name="orgaRepresentantLegal" id="orgaRepresentantLegal" {...register("orgaRepresentantLegal")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaRepresentantLegal}/>
                        <small className="text-danger">{errors.orgaRepresentantLegal?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Fonction</Form.Label>
                        <Form.Control type="text" name="orgaRepresentantLegalFonction" id="orgaRepresentantLegalFonction" {...register("orgaRepresentantLegalFonction")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaRepresentantLegalFonction}/>
                        <small className="text-danger">{errors.orgaRepresentantLegalFonction?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Adresse email</Form.Label>
                        <Form.Control type="text" name="orgaRepresentantLegalMail" id="orgaRepresentantLegalMail" {...register("orgaRepresentantLegalMail")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaRepresentantLegalMail}/>
                        <small className="text-danger">{errors.orgaRepresentantLegalMail?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Téléphone</Form.Label>
                        <Form.Control type="text" name="orgaRepresentantLegalTel" id="orgaRepresentantLegalTel" {...register("orgaRepresentantLegalTel")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaRepresentantLegalTel}/>
                        <small className="text-danger">{errors.orgaRepresentantLegalTel?.message}</small>
                    </Form.Group>
                </Col>
            </Row>

            <hr/>
            
            <Row>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Adresse email pour la facturation</Form.Label>
                        <Form.Control type="text" name="orgaFacturationMail" id="orgaFacturationMail" {...register("orgaFacturationMail")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaFacturationMail}/>
                        <small className="text-danger">{errors.orgaFacturationMail?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Téléphone du contact pour la facturation</Form.Label>
                        <Form.Control type="text" name="orgaFacturationTel" id="orgaFacturationTel" {...register("orgaFacturationTel")} disabled={watch("idStructureClient")} isInvalid={!!errors.orgaFacturationTel}/>
                        <small className="text-danger">{errors.orgaFacturationTel?.message}</small>
                    </Form.Group>
                </Col>
            </Row>
        </div>

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Suivi de cette demande par</h5></center>
            <Row>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre Nom/Prénom</Form.Label>
                        <Form.Control type="text" name="orgaRepresentePar" id="orgaRepresentePar" {...register("orgaRepresentePar")} disabled={HabilitationService.habilitations ?  true : false} isInvalid={!!errors.orgaRepresentePar}/>
                        <small className="text-danger">{errors.orgaRepresentePar?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre fonction</Form.Label>
                        <Form.Control type="text" name="orgaRepresenteParFonction" id="orgaRepresenteParFonction" {...register("orgaRepresenteParFonction")} isInvalid={!!errors.orgaRepresenteParFonction}/>
                        <small className="text-danger">{errors.orgaRepresenteParFonction?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre adresse email</Form.Label>
                        <Form.Control type="text" name="orgaRepresenteParMail" id="orgaRepresenteParMail" {...register("orgaRepresenteParMail")} disabled={HabilitationService.habilitations ?  true : false} isInvalid={!!errors.orgaRepresenteParMail}/>
                        <small className="text-danger">{errors.orgaRepresenteParMail?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre téléphone</Form.Label>
                        <Form.Control type="text" name="orgaRepresenteParTel" id="orgaRepresenteParTel" {...register("orgaRepresenteParTel")} disabled={HabilitationService.habilitations ?  true : false} isInvalid={!!errors.orgaRepresenteParTel}/>
                        <small className="text-danger">{errors.orgaRepresenteParTel?.message}</small>
                    </Form.Group>
                </Col>
            </Row>
        </div>

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Contact sur place le jour J</h5></center>
            <Row>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Nom/Prénom <small>(<Link onClick={contactSurPlaceIdentique}>C'est moi !</Link>)</small></Form.Label>
                        <Form.Control type="text" name="orgaContactLocal" id="orgaContactLocal" {...register("orgaContactLocal")} isInvalid={!!errors.orgaContactLocal}/>
                        <small className="text-danger">{errors.orgaContactLocal?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Fonction</Form.Label>
                        <Form.Control type="text" name="orgaContactLocalFonction" id="orgaContactLocalFonction" {...register("orgaContactLocalFonction")} isInvalid={!!errors.orgaContactLocalFonction}/>
                        <small className="text-danger">{errors.orgaContactLocalFonction?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Téléphone</Form.Label>
                        <Form.Control type="text" name="orgaContactLocalTel" id="orgaContactLocalTel" {...register("orgaContactLocalTel")} isInvalid={!!errors.orgaContactLocalTel}/>
                        <small className="text-danger">{errors.orgaContactLocalTel?.message}</small>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    </>);
};


DemandeDPSStep1.propTypes = {};

export default DemandeDPSStep1;